// src/components/hooks/useMetodoPago.ts

import { supabase } from '@/lib/supabaseClient';

/**
 * Abre el Billing Portal de Stripe (hospedado por Stripe) para que la
 * empresa pueda cambiar su método de pago y consultar su historial de
 * facturas. Devuelve la URL para redirigir.
 *
 * NOTA: el portal se abre con una configuración RESTRINGIDA definida en
 * la Edge Function `crear-portal-cliente`: solo permite gestionar el
 * método de pago, ver facturas y editar datos fiscales. La cancelación y
 * el cambio de suscripciones están deshabilitados a propósito — eso se
 * gestiona desde la propia aplicación, que es donde están las reglas de
 * cupo de trabajadores y de qué vende cada plan.
 */
export async function abrirPortalCliente(
  idEmpresa: string
): Promise<{ url: string } | null> {
  const { data, error } = await supabase.functions.invoke('crear-portal-cliente', {
    body: {
      id_empresa: idEmpresa,
      return_url: `${window.location.origin}/panel-empresa/subscriptions`,
    },
  });

  if (error) {
    console.error('Error al abrir el portal de facturación:', error);
    return null;
  }

  return data as { url: string };
}